import React from "react";
import { onAppPaneGroupReady } from "owa-app-pane-group-actions";
import { DrawerPane, type DrawerPaneProps } from "owa-drawer";
import { observer } from "owa-mobx-react";
import { useAction } from "owa-react-hooks/lib/useAction";
import { appPanesConfiguration } from "../config/appPanesConfiguration";

import AddinsPane from "./panes/AddinsPane";
import ChatCopilotPane from "./panes/ChatCopilotPane";
import FeedbackPane from "./panes/FeedbackPane";
import GetDiagnostics from "./panes/GetDiagnostics";
import MyDayPane from "./panes/MyDayPane";
import SupportPane from "./panes/SupportPane";
import { GraphicsPane } from "owa-editor-content-picker";
import { AccCheckerDrawer } from "owa-editor-acc-checker";

const defaultExport: React.FunctionComponent = observer(function AppPaneGroup() {
    useAction(onAppPaneGroupReady);
    
    const drawerPanes: ReadonlyArray<DrawerPaneProps> = React.useMemo(() => appPanesConfiguration
        .filter(config => !config.isStandaloneComponent)
        .map(config => ({
        ...config,
        children: config.getChildren(),
        headerText: config.getHeaderText(),
    })), []);
    
    return (<>
            {/* Standalone components */}
            <AddinsPane />
            <ChatCopilotPane />
            <FeedbackPane />
            <GetDiagnostics />
            <MyDayPane />
            <SupportPane />
            <GraphicsPane />
            <AccCheckerDrawer />
            {/* Auto-generated panes */}
            {drawerPanes.map(({ paneId, headerText, children, showCloseButton, headerClassName, titleClassName, bodyClassName, preserveContentOnDismiss, }) => (<DrawerPane key={paneId} paneId={paneId} headerText={headerText} showCloseButton={showCloseButton} headerClassName={headerClassName} titleClassName={titleClassName} bodyClassName={bodyClassName} preserveContentOnDismiss={preserveContentOnDismiss} role={"complementary"}>
                        {children}
                    </DrawerPane>))}
        </>);
}, "AppPaneGroup");
export default defaultExport;
